import {
    FETCH_RULES_REQUEST, FETCH_RULES_SUCCESS, FETCH_RULES_FAILURE,
    CREATE_RULE_SUCCESS, UPDATE_RULE_SUCCESS, DELETE_RULE_SUCCESS
  } from '../actions/ruleActions';
  
  const initialState = {
    rules: [],
    loading: false,
    error: null,
  };
  
  export default function ruleReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_RULES_REQUEST:
        return { ...state, loading: true };
      case FETCH_RULES_SUCCESS:
        return { ...state, loading: false, rules: action.payload };
      case CREATE_RULE_SUCCESS:
        return { ...state, rules: [...state.rules, action.payload] };
      case UPDATE_RULE_SUCCESS:
        return {
          ...state,
          rules: state.rules.map((rule) => rule.id === action.payload.id ? action.payload : rule),
        };
      case DELETE_RULE_SUCCESS:
        return {
          ...state,
          rules: state.rules.filter((rule) => rule.id !== action.payload),
        };
      default:
        return state;
    }
  }
  